export const landingPagesRequests = (requestor: any) => ({
  /**
   * @name getPages
   * @description Function used to make request to get all landing pages
   */

  getPages: async () => {
    const url = `landing-pages`;
    const response = await requestor({
      method: 'GET',
      url,
    });

    return response;
  },
  updatePage: async (pageId: string, data: any) => {
    const url = `landing-pages/${pageId}`;
    const response = await requestor({
      method: 'PUT',
      url,
      data,
    });
    return response;
  },
});
